import { Flex, chakra, useDisclosure } from '@chakra-ui/react';
import React from 'react';

import type { AddressFromToFilter } from 'types/api/address';
import type { TokenType } from 'types/api/token';

import useIsInitialLoading from 'lib/hooks/useIsInitialLoading';
import CsvExportDialog from 'ui/csvExport/CsvExportDialog';
import Skeleton from 'ui/shared/chakra/Skeleton';
import ExportButton from 'ui/shared/ExportButton';

interface Props {
  address: string;
  filterValue?: AddressFromToFilter;
  typeFilter?: Array<TokenType>;
  tokenFilter?: string;
  className?: string;
  isLoading?: boolean;
}

const AddressTokenTransfersCsvExportButton = ({
  address,
  filterValue,
  typeFilter,
  tokenFilter,
  className,
  isLoading,
}: Props) => {
  const dialog = useDisclosure();
  const isInitialLoading = useIsInitialLoading(isLoading);

  if (isInitialLoading) {
    return (
      <Flex className={ className } flexShrink={ 0 } alignItems="center">
        <Skeleton h="32px" w="120px" borderRadius="sm"/>
      </Flex>
    );
  }

  return (
    <>
      <ExportButton className={ className } onClick={ dialog.onOpen }>
        Export
      </ExportButton>
      <CsvExportDialog
        isOpen={ dialog.isOpen }
        onClose={ dialog.onClose }
        title="Export Token Transfers"
        hash={ address }
        resource="csv_export_address_token_transfers"
        filterValue={ filterValue }
        typeFilter={ typeFilter?.join(',') }
        tokenAddressHashFilter={ tokenFilter }
        fileNameTemplate="token_transfers"
        exportType="token-transfers"
      />
    </>
  );
};

export default React.memo(chakra(AddressTokenTransfersCsvExportButton));
